import { parallaxStore } from '../model/stores';
import { environment } from './environment';
import { visibility } from './visibility';

/**
 *  The component should change its look only while it is within the viewport
 *  and if the user does scroll the page only.
 */

let currentPageOffset;

let getVisibility = (element) => {
	
	// Check whether we are in the visible viewport
	let viewportHeight = environment().innerHeight() * 1;
	const childRect = element.getBoundingClientRect();
	
	if (childRect.height > viewportHeight) {
		viewportHeight = childRect.height;
	}
	
	const parentRect = {
		bottom: viewportHeight + (environment().innerHeight() - viewportHeight) / 2,
		height: viewportHeight,
		left: 0,
		right: environment().innerWidth(),
		top: (environment().innerHeight() - viewportHeight) / 2,
		width: environment().innerWidth()
	};
	
	return visibility().getOverlap(parentRect, childRect);
};

export function animateElement(value, element, cssCallback, threshold = 0) {

	currentPageOffset = value;

	if (getVisibility(element) > threshold) {
		cssCallback(value);
	}
}

export function freezeElement(value, element, cssCallback, threshold = 0) {

	currentPageOffset = value;
	
	if (getVisibility(element) <= threshold) {
		cssCallback(value);
	}
}
